import { createContext, useState, useEffect } from 'react'

interface AlertContextType {
  showMessage: {
    show: boolean
    message: string
    type: 'Success' | 'Error' | 'Warning' | 'Info'
  }
  setShowMessage: React.Dispatch<
    React.SetStateAction<{
      show: boolean
      message: string
      type: 'Success' | 'Error' | 'Warning' | 'Info'
    }>
  >
}

export const AlertContext = createContext<AlertContextType>({
  showMessage: {
    show: false,
    message: '',
    type: 'Info',
  },
  setShowMessage: () => null,
})

export const AlertProvider: React.FC = ({ children }) => {
  const [showMessage, setShowMessage] = useState<
    AlertContextType['showMessage']
  >({
    show: false,
    message: '',
    type: 'Info',
  })
  // Hook to reset the alert message after 5 seconds
  useEffect(() => {
    if (showMessage.show) {
      const timeoutId = setTimeout(() => {
        setShowMessage((prevState) => ({ ...prevState, show: false }))
      }, 5000)
      return () => clearTimeout(timeoutId)
    }
  }, [showMessage.show])

  return (
    <AlertContext.Provider value={{ showMessage, setShowMessage }}>
      {children}
    </AlertContext.Provider>
  )
}
